export default {
    chats: {
        start: {
            events: [
                {
                    tasks: [
                        {
                            method: "HttpRequest",
                            data: {
                                method: "get",
                                body: "{}",
                                error: "{{ http_result.message }}",
                                url: "https://dog.ceo/api/breeds/image/random"
                            },
                            error: false
                        },
                        {
                            method: "SendPhoto",
                            data: {
                                photo: "{{ http_result.message }}",
                                caption: null,
                                to: "{{chat_id}}",
                                reply_markup: {
                                    inline_keyboard: [
                                        [
                                            {
                                                text: "Next",
                                                callback_data: "next",
                                                id: "4732",
                                                type: "callback_data"
                                            }
                                        ]
                                    ]
                                }
                            },
                            error: false
                        }
                    ]
                }
            ]
        },
        "Next Image": {
            events: [
                {
                    tasks: [
                        {
                            method: "HttpRequest",
                            data: {
                                method: "get",
                                body: "{}",
                                error: "{{ http_result.message }}",
                                url: "https://dog.ceo/api/breeds/image/random"
                            },
                            error: false
                        },
                        {
                            method: "EditMessageMedia",
                            data: {
                                message_id: "{{incoming_message_id}}",
                                media: {
                                    type: "photo",
                                    caption: null,
                                    media: "{{ http_result.message }}"
                                },
                                reply_markup: {
                                    inline_keyboard: [
                                        [
                                            {
                                                text: "Next",
                                                callback_data: "next",
                                                id: "16585",
                                                type: "callback_data"
                                            }
                                        ]
                                    ]
                                },
                                chat_id: "{{user_id}}"
                            },
                            error: false
                        }
                    ]
                }
            ]
        }
    },
    actions: {
        callbacks: [
            {
                button: {
                    text: "Next",
                    callback_data: "next",
                    id: "4732",
                    type: "callback_data"
                },
                chat: "Next Image"
            },
            {
                button: {
                    text: "Next",
                    callback_data: "next",
                    id: "16585",
                    type: "callback_data"
                },
                chat: "Next Image"
            }
        ],
        commands: [
            {
                description: "Start me to browse dog pictures",
                admin: false,
                error: false,
                command: "start",
                chat: "start"
            }
        ],
        reply_buttons: []
    },
    variables: {}
};